"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectMapper = exports.ProjectMapper = void 0;
const project_models_1 = require("../models/projects/project.models");
const responses_1 = require("../responses");
const base_mapper_1 = require("./base-mapper");
class ProjectMapper extends base_mapper_1.BaseMapper {
    mapValidateProjectContentResponse(response) {
        return new responses_1.ProjectResponses.ValidateProjectContentResponse(super.mapResponseDebug(response), response.data, {
            project: this.mapProjectModel(response.data.project),
            typeIssues: response.data.type_issues.map(m => this.mapTypeIssue(m)),
            variantIssues: response.data.variant_issues.map(m => this.mapVariantIssue(m))
        });
    }
    mapProjectInformationResponse(response) {
        return new responses_1.ProjectResponses.ProjectInformationResponse(super.mapResponseDebug(response), response.data, {
            project: new project_models_1.ProjectModels.ProjectInformationModel(response.data.id, response.data.name, response.data.environment)
        });
    }
    mapProjectModel(raw) {
        return new project_models_1.ProjectModels.ProjectReportModel(raw.id, raw.name);
    }
    mapTypeModel(raw) {
        return new project_models_1.ProjectModels.ProjectTypeModel(raw.id, raw.name, raw.codename);
    }
    mapItemModel(raw) {
        return new project_models_1.ProjectModels.ProjectVariantContentItemModel(raw.id, raw.name, raw.codename);
    }
    mapLanguageModel(raw) {
        return new project_models_1.ProjectModels.ProjectVariantLanguageModel(raw.id, raw.name, raw.codename);
    }
    mapIssueModel(raw) {
        return new project_models_1.ProjectModels.ProjectIssueModel(this.mapVariantElementModel(raw.element), raw.messages);
    }
    mapTypeIssue(raw) {
        return new project_models_1.ProjectModels.ProjectTypeIssueModel(this.mapTypeModel(raw.type), raw.issues.map(m => this.mapIssueModel(m)));
    }
    mapVariantIssue(raw) {
        return new project_models_1.ProjectModels.ProjectVariantIssueModel(this.mapItemModel(raw.item), this.mapLanguageModel(raw.language), raw.issues.map(m => this.mapIssueModel(m)));
    }
    mapVariantElementModel(raw) {
        return new project_models_1.ProjectModels.ProjectVariantElementModel(raw.id, raw.name, raw.codename);
    }
}
exports.ProjectMapper = ProjectMapper;
exports.projectMapper = new ProjectMapper();
//# sourceMappingURL=project-mapper.js.map